"use strict";

function e(e) {
  return e && "object" == typeof e && "default" in e ? e.default : e;
}

Object.defineProperty(exports, "__esModule", {
  value: !0
});
var r = e(require("@babel/runtime/helpers/slicedToArray")),
    t = e(require("react")),
    n = e(require("@babel/runtime/helpers/defineProperty")),
    o = t.createContext(null);

function i() {
  var e = t.useContext(o);
  return e;
}

function u(e) {
  if ("undefined" == typeof Symbol || null == e[Symbol.iterator]) {
    if (Array.isArray(e) || (e = function (e, r) {
      if (!e) return;
      if ("string" == typeof e) return a(e, r);
      var t = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === t && e.constructor && (t = e.constructor.name);
      if ("Map" === t || "Set" === t) return Array.from(t);
      if ("Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return a(e, r);
    }(e))) {
      var r = 0,
          t = function t() {};

      return {
        s: t,
        n: function n() {
          return r >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[r++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: t
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var _n,
      o,
      i = !0,
      u = !1;

  return {
    s: function s() {
      _n = e[Symbol.iterator]();
    },
    n: function n() {
      var e = _n.next();

      return i = e.done, e;
    },
    e: function e(_e2) {
      u = !0, o = _e2;
    },
    f: function f() {
      try {
        i || null == _n.return || _n.return();
      } finally {
        if (u) throw o;
      }
    }
  };
}

function a(e, r) {
  (null == r || r > e.length) && (r = e.length);

  for (var t = 0, n = new Array(r); t < r; t++) {
    n[t] = e[t];
  }

  return n;
}

var c = /<(\d+)>(.*?)<\/\1>|<(\d+)\/>/,
    l = /(?:\r\n|\r|\n)/g;

function f(e) {
  if (!e.length) return [];
  var t = e.slice(0, 4),
      n = r(t, 4),
      o = n[0],
      i = n[1],
      u = n[2],
      a = n[3];
  return [[parseInt(o || u), i || "", a]].concat(f(e.slice(4, e.length)));
}

function s(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    r && (n = n.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, n);
  }

  return t;
}

function p(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? s(Object(t), !0).forEach(function (r) {
      n(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : s(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function d(e) {
  var n = i(),
      o = n.i18n,
      a = n.defaultRender,
      s = e.render,
      d = void 0 === s ? a : s,
      y = e.id,
      v = e.message,
      b = e.formats,
      m = p({}, e.values),
      h = p({}, e.components);
  m && Object.keys(m).forEach(function (e) {
    var r = m[e];

    if (t.isValidElement(r)) {
      var n = Object.keys(h).length;
      h[n] = r, m[e] = "<".concat(n, "/>");
    }
  });
  var g = o && "function" == typeof o._ ? o._(y, m, {
    message: v,
    formats: b
  }) : y,
      O = g ? function e(n) {
    var o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        i = n.replace(l, "").split(c);
    if (1 === i.length) return n;
    var a = [],
        s = i.shift();
    s && a.push(s);
    var p,
        d = u(f(i));

    try {
      for (d.s(); !(p = d.n()).done;) {
        var y = r(p.value, 3),
            v = y[0],
            b = y[1],
            m = y[2],
            h = o[v];
        a.push(t.cloneElement(h, {
          key: v
        }, b ? e(b, o) : h.props.children)), m && a.push(m);
      }
    } catch (e) {
      d.e(e);
    } finally {
      d.f();
    }

    return a;
  }(g, h) : null;
  return null == d ? O : "string" == typeof d ? t.createElement(d, {}, O) : t.isValidElement(d) ? t.cloneElement(d, {}, O) : t.createElement(d, {
    id: y,
    translation: O,
    message: v
  });
}

d.defaultProps = {
  values: {},
  components: {}
}, exports.I18nProvider = function (e) {
  var n = t.useState(c()),
      i = r(n, 2),
      u = i[0],
      a = i[1];

  function c() {
    return {
      i18n: e.i18n,
      defaultRender: e.defaultRender
    };
  }

  return t.useEffect(function () {
    var r = e.i18n.on("change", function () {
      return a(c());
    });
    return function () {
      return r();
    };
  }, []), t.createElement(o.Provider, {
    value: u
  }, e.children);
}, exports.Trans = d, exports.useLingui = i;